"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
if (!('RelativeTimeFormat' in Intl)) {
    Object.defineProperty(Intl, 'RelativeTimeFormat', {
        value: _1.default,
        writable: true,
        enumerable: false,
        configurable: true,
    });
}
